import { SbbFileSelectorDropzone } from "@sbb-esta/lyne-react/file-selector";
import { toastError } from "helpers";
import { createLogger } from "logging";
import { useApi, useDocumentsPanel, useTranslations } from "providers";

const logger = createLogger("DocumentsPanel.UploadForm");

export const UploadForm = () => {
  const i18n = useTranslations();
  const { workingDocumentsApi } = useApi();
  const { agendaItem, reloadMeeting } = useDocumentsPanel();

  if (!agendaItem) {
    return null;
  }

  const { id, canUploadDocument } = agendaItem;
  if (!canUploadDocument) {
    return null;
  }

  return (
    <div className="upload-form">
      <SbbFileSelectorDropzone
        multiple
        multipleMode="persistent"
        titleContent={i18n.Upload_SelectTitle}
        size="s"
        onFilechanged={(event) => {
          const files = event.detail;
          logger.debug("onFilechanged", files);
          files.forEach((file) => {
            const formData = new FormData();
            formData.append("file", file);
            workingDocumentsApi
              .uploadAgendaItemFile(id, formData)
              .then(() => reloadMeeting())
              .catch((error: unknown) => {
                toastError(i18n.Upload_StatusUploadFailed, error);
              });
          });
        }}
      />
    </div>
  );
};
